import { formatNumber } from 'modules/productAnalytics/utils';
import { displayDate } from 'utils/date';
import { Cell, RightAlignText, TabularNumberFont } from './Report.styled';

export const createSummaryViewColumns = (headers /*: string[] */, highLevelMetrics) => [
  {
    value: 'id',
    name: 'ID',
    RowCell: ({ row }) => (
      <Cell>
        <a href={row.link}>{row.id}</a>
      </Cell>
    ),
  },
  {
    value: 'name',
    name: 'Name',
    RowCell: ({ row }) => (
      <Cell>
        <a href={row.link}>{row.name}</a>
      </Cell>
    ),
  },
  ...headers.map((header) => {
    if (highLevelMetrics) {
      // it's possible that the current list of highLevelMetrics available to the project is different from
      // the campaign's metrics: e.g., the project used to have 'showPurchases' turned on in project settings
      // and now it is turned off but the campaign still has 'purchase' metrics attached to it
      const highLevelMetricHeader = highLevelMetrics.find((metric) => metric.enumName === header);
      const name = highLevelMetricHeader?.name || header;
      const value = highLevelMetricHeader?.enumName || header;
      return {
        name,
        value,
        align: 'flex-end',
        RowCell: ({ row }) => (
          <Cell>
            <RightAlignText>
              <TabularNumberFont>
                {row[value] ? formatNumber(name, row[value]) : '-'}
              </TabularNumberFont>
            </RightAlignText>
          </Cell>
        ),
      };
    }
    return {
      name: header,
      value: header,
      RowCell: ({ row }) => <Cell>{row[header] || '-'}</Cell>,
    };
  }),
];

export const createDateTimeViewColumns = (dateTimeViewData) => [
  {
    value: 'timestamp',
    name: 'Date',
    RowCell: ({ row }) => (
      <Cell>
        <div>{displayDate(row.timestamp, row.dateFormat)}</div>
      </Cell>
    ),
  },
  ...dateTimeViewData.map(({ metric }) => {
    return {
      value: metric.enumName,
      name: metric.name,
      align: 'flex-end',
      RowCell: ({ row }) => (
        <Cell>
          <RightAlignText>
            <TabularNumberFont>
              {formatNumber(metric.enumName, row[metric.enumName])}
            </TabularNumberFont>
          </RightAlignText>
        </Cell>
      ),
    };
  }),
];
